import { Profile, TranslationLanguage, normalizeTranslationLanguage } from '@lingoping/core';
import { StorageManager } from '../storage/index.js';

/** The language cards are shown in unless a review window switches it: `profile.native_language`. */
export function baseTranslationLanguage(
  profile: Pick<Profile, 'native_language'> | null | undefined
): TranslationLanguage {
  return normalizeTranslationLanguage(profile?.native_language);
}

export async function getBaseTranslationLanguage(): Promise<TranslationLanguage> {
  return baseTranslationLanguage(await StorageManager.getProfile());
}

/**
 * Saves the user's translation language: here at once and, for a real signed-in account, on the
 * server with the next sync, so their other devices follow. Never called by the review window's
 * quick switch, which is per window and not saved anywhere.
 */
export async function saveTranslationLanguage(language: TranslationLanguage): Promise<Profile> {
  return StorageManager.saveSettings({ native_language: normalizeTranslationLanguage(language) });
}
